import { initTracking } from '@ramp106/omrjs-tracking-reviews'
import { createSentryPiniaPlugin } from '@sentry/vue'
import { ApolloClients } from '@vue/apollo-composable'
import FloatingVue from 'floating-vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp, provide, h } from 'vue'
import FlagIcon from 'vue-flag-icon'

import {
  myomrApolloClient,
  reviewsApolloClient,
  hygraphApolloClient,
  jobsApolloClient,
  platformApiApolloClient,
} from '@/plugins/vue-apollo'
import { bootstrapConsentAndTagManagers } from '@/services/consentBootstrap'
import { installPageViewTracking } from '@/services/pageViewTracking'
import { initPosthog, ph } from '@/services/posthog'
import { initSentry } from '@/services/sentry'

import App from './App.vue'
import RolesMixin from './mixins/rolesMixin'
import i18n from './plugins/i18n'
import router from './router'

import '@mdi/font/css/materialdesignicons.css'
import 'floating-vue/dist/style.css'
import '@/styles/tailwind.css'

const app = createApp({
  mixins: [RolesMixin],
  setup() {
    provide(ApolloClients, {
      default: myomrApolloClient,
      reviews: reviewsApolloClient,
      hygraph: hygraphApolloClient,
      jobs: jobsApolloClient,
      platformApi: platformApiApolloClient,
    })
  },

  render: () => h(App),
})
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
pinia.use(createSentryPiniaPlugin())

initSentry(app, router)

app.use(i18n)
app.use(pinia)
app.use(router)
if (!import.meta.env.DEV) {
  bootstrapConsentAndTagManagers()
}
initPosthog()
initTracking({ app: 'manager', posthog: ph, debug: import.meta.env.DEV })
installPageViewTracking(router)
app.use(FloatingVue)
app.use(FlagIcon)
app.mount('#app')
